const toastTypes = {
  Success: 'success',
  Error: 'error',
  Warning: 'warning',
};

Object.freeze(toastTypes);

export default toastTypes;
